// extracted by mini-css-extract-plugin
module.exports = {"resultsContainer":"_3DgEZ__resultsContainer","headerTitle":"_1fdq5__headerTitle"};